export default __webpack_public_path__ + "static/media/woman.84df9209.png";